import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2B2B2B] rounded-t-[40px] mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-4">
            <img
              src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/69489545e86907aa53371b0a163c3f48.png"
              alt="Art Throng Home"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Elevating homes, enriching lives
            </p>
          </div>

          {/* Services Column */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Interior Design
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Cleaning
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Maintenance
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Renovation
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('packages')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Packages
                </button>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-[#8B9B7E] transition-colors text-sm cursor-pointer">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div className="lg:col-span-4">
            <h3 className="text-white font-semibold mb-4">Stay Updated</h3>
            <p className="text-gray-400 text-sm mb-4">
              Get home care tips & exclusive offers
            </p>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 bg-[#3a3a3a] border border-gray-600 text-white px-4 py-3 rounded-lg focus:outline-none focus:border-[#8B9B7E] text-sm"
              />
              <button className="bg-white text-[#2B2B2B] w-12 h-12 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
            <div className="flex items-center space-x-4 mt-6">
              <a
                href="https://www.instagram.com/art.throng/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#8B9B7E] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a
                href="https://www.facebook.com/ArtThrong"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#8B9B7E] transition-colors cursor-pointer"
              >
                <i className="ri-facebook-circle-line text-2xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/art-throng/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#8B9B7E] transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-box-line text-2xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Art Throng Home. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-[#8B9B7E] text-sm mt-4 md:mt-0 cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
